import { render, staticRenderFns } from "./lk-services-item.vue?vue&type=template&id=47fc595e&"
import script from "./lk-services-item.vue?vue&type=script&lang=js&"
export * from "./lk-services-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/lk/lk-services-item/lk-services-item.vue
// module id = 442
// module chunks = 0